var nb_NO = {};
module['exports'] = nb_NO;
nb_NO.title = "Norwegian";
nb_NO.address = require("./address");
nb_NO.company = require("./company");
nb_NO.internet = require("./internet");
nb_NO.name = require("./name");
nb_NO.phone_number = require("./phone_number");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nb_NO/index.js
 ** module id = 844
 ** module chunks = 0
 **/